import React from "react";
import classes from "./Loader.module.css";

const Loader = (props) => {
  return (
    <div className={classes.Loader}>
      <span className={classes.Loader}>
        <span className={classes.LoaderInner}></span>
      </span>
    </div>
  );
};

export default Loader;
